import React from "react";
import "./ProductPrice.css";
import bracketLogo from "../../img/navigation/Bracket.svg";
import discountLogo from "../../img/navigation/Discount.svg";
import InfoIcon from "@mui/icons-material/Info";
import { connect, useSelector } from "react-redux";
import { selectUser } from "../../features/auth/authSlice";
import {
  selectIsOverlayVisible,
  toggleOverlay,
} from "../../store/slices/headerSlice";
import {
  calculateDealerPrice,
  calculateGST,
  calculateUpdatedDiscountPercentage,
  formatWithCommasWithDecimal,
} from "../../utils/utils";
import { Tooltip } from "@mui/material";

function ProductPrice({ selectProduct, isOverlayVisible, toggleOverlay }) {
  const selectedVariant = useSelector(
    (state) => state.productDetail.selectedVariant
  );
  return (
    <div className="productPrice-container">
      <div className="productPrice-left-container">
        <div className="productPrice-mrp-price-container">
          <span className="productPrice-mrp-price-heading">Sale Price</span>
          <div className="productPrice-mrp-price-main-container">
            <div className="productPrice-ndp-offer-price-container">
              <span className="productPrice-mrp-price-span">
                ₹
                {selectedVariant &&
                  selectedVariant?.NDP_Price &&
                  formatWithCommasWithDecimal(
                    calculateDealerPrice(
                      parseInt(selectedVariant?.MRP_price),
                      parseInt(selectedVariant?.NDP_Price),
                      parseInt(selectProduct && selectProduct[0]?.GST)
                    )
                  )}
              </span>
            </div>
          </div>
        </div>
        <div className="productPrice-ndp-price-container">
          <span className="productPrice-ndp-price-heading">MRP</span>
          <span className="productPrice-ndp-price-span">
            ₹
            {formatWithCommasWithDecimal(
              parseInt(selectedVariant && selectedVariant?.MRP_price)
            )}{" "}
          </span>
        </div>
        {selectProduct &&
          selectProduct[0]?.Manufacturer === "GARRARI BIKES" && (
            <span className="text-gray-600 text-[12px] mt-3 flex items-center">
              <Tooltip
                title="Shipping charges will be collected by the delivery agent upon delivery."
                arrow
                placement="top-start"
              >
                <InfoIcon
                  sx={{
                    fontSize: "16px",
                    color: "gray",
                    marginLeft: "4px",
                    cursor: "pointer",
                  }}
                />
              </Tooltip>
              &nbsp;Shipping charges applicable
            </span>
          )}
      </div>
      {calculateUpdatedDiscountPercentage(
        selectedVariant && selectedVariant?.MRP_price,
        selectedVariant && selectedVariant?.NDP_Price,
        selectProduct && selectProduct[0]?.GST
      ) >= 1 && (
        <>
          <div className="productPrice-divider-container">
            <img
              loading="lazy"
              src={bracketLogo}
              alt=""
              className="productPrice-divider-img"
            />
          </div>
          <div className="productPrice-right-container">
            <div className="productPrice-right-margin-container">
              <img
                loading="lazy"
                src={discountLogo}
                alt=""
                className="productPrice-right-margin-logo"
              />
              <span className="productPrice-right-margin-span">
                {calculateUpdatedDiscountPercentage(
                  selectedVariant?.MRP_price,
                  parseInt(selectedVariant?.NDP_Price),
                  selectProduct && selectProduct[0]?.GST
                )}
              </span>
              % Off
            </div>
          </div>
        </>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  isOverlayVisible: selectIsOverlayVisible(state),
});
const mapDispatchToProps = {
  toggleOverlay,
};
export default connect(mapStateToProps, mapDispatchToProps)(ProductPrice);
